import { render } from "./RollerLoader.vue?vue&type=template&id=e1d2260c&scoped=true"
const script = {}

import "./RollerLoader.vue?vue&type=style&index=0&id=e1d2260c&scoped=true&lang=css"

import exportComponent from "E:\\_____LARAGON\\laragon\\www\\finalMatilda\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1d2260c"]])

export default __exports__